import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Paymodecheckouts() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [paymodetype, setpaymodetype] = useState("");
    const [total, settotal] = useState(0);
    const [payHistoryData, setpayHistoryData] = useState([]);
    const [paymodes, setpaymodes] = useState([]);





    useEffect(() => {
        auth.onAuthStateChanged((user) => {
        });
    });

    useEffect(() => {
        fetchData1()
    }, []);


    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'paymentmodes'), orderBy('createdAt', 'asc'))
            onSnapshot(q, (querySnapshot) => {
                setpaymodes(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }


    const getReport = async () => {
    if (!fromDate || !toDate || !paymodetype) {
        Toast.fire({ icon: "error", title: 'Please select all fields' });
        return;
    }

    setloading(true);
    setpayHistoryData([]);

    const startDate = moment(fromDate).format("YYYY-MM-DD");
    const endDate = moment(toDate).format("YYYY-MM-DD");

    try {
        const payHistoryMatches = [];

        // Fetch payhistory entries where paymode1 or paymode2 match
        const q1 = query(collection(db, 'payhistory'), where('paymode1', '==', paymodetype));
        const q2 = query(collection(db, 'payhistory'), where('paymode2', '==', paymodetype));

        const [snap1, snap2] = await Promise.all([getDocs(q1), getDocs(q2)]);

        const bookingIdSet = new Set();

        [...snap1.docs, ...snap2.docs].forEach(docSnap => {
            const data = docSnap.data();
            payHistoryMatches.push({ id: docSnap.id, ...data });
            bookingIdSet.add(data.bookingid);
        });

        const bookingIds = [...bookingIdSet];
        if (bookingIds.length === 0) {
            Toast.fire({ icon: "info", title: "No matching payments found." });
            setloading(false);
            return;
        }

        // Fetch bookings in chunks
        const chunkSize = 30;
        const bookingsMap = {};
        for (let i = 0; i < bookingIds.length; i += chunkSize) {
            const chunk = bookingIds.slice(i, i + chunkSize);
            const bq = query(collection(db, 'bookings'), where('__name__', 'in', chunk));
            const bSnap = await getDocs(bq);

            bSnap.forEach(bdoc => {
                const bdata = bdoc.data();
                const cDate = bdata.checkindate;
                if (cDate >= startDate && cDate <= endDate) {
                    bookingsMap[bdoc.id] = bdata;
                }
            });
        }

        // Fetch all used paymode names
        const allPaymodeIds = new Set(
            payHistoryMatches.flatMap(p => [p.paymode1, p.paymode2])
        );
        const paymodeMap = {};

        await Promise.all([...allPaymodeIds].map(async (pmid) => {
            const ref = doc(db, 'paymentmodes', pmid);
            const snap = await getDoc(ref);
            if (snap.exists()) {
                paymodeMap[pmid] = snap.data().paymode;
            }
        }));

        // Deduplicate by booking ID
        const seenBookings = new Set();
        const result = [];

        payHistoryMatches.forEach(item => {
            if (!bookingsMap[item.bookingid] || seenBookings.has(item.bookingid)) return;

            result.push({
                ...item,
                paymode1: paymodeMap[item.paymode1] || '',
                paymode2: paymodeMap[item.paymode2] || '',
                booking: bookingsMap[item.bookingid]
            });

            seenBookings.add(item.bookingid);
        });

        setpayHistoryData(result);
    } catch (error) {
        Toast.fire({ icon: "error", title: error.message });
    }

    setloading(false);
};




    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| Paymode Wise Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-3'>
                                                <label>Pay Mode 2</label>
                                                <select className='form-control' value={paymodetype} onChange={(e) => setpaymodetype(e.target.value)} >
                                                    <option></option>
                                                    {
                                                        paymodes.map((item, index) =>
                                                            <option key={index} value={item.id}>{item.data.paymode}</option>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                            <div className='col-sm-3'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Customer Name</th>
                                            <th>Mobile</th>
                                            <th>Check-in DateTime</th>
                                            <th>Pay Mode 1</th>
                                            <th>Amount 1</th>
                                            <th>Pay Mode 2</th>
                                            <th>Amount 2</th>
                                            <th>Total</th>
                                            <th>Rooms</th>
                                            <th>Action</th> {/* New Column for Print Button */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            payHistoryData.length > 0 ? (() => {
                                                let grandTotal = 0;
                                                const rows = payHistoryData.map((item, index) => {
                                                    const booking = item.booking || {};
                                                    const customer = booking.customers || {};
                                                    const rooms = booking.rooms || [];

                                                    const amount1 = parseFloat(item.amount1 || 0);
                                                    const amount2 = parseFloat(item.amount2 || 0);
                                                    const totalAmount = amount1 + amount2;

                                                    grandTotal += totalAmount;

                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{customer.custname || '-'}</td>
                                                            <td>{customer.mobile || '-'}</td>
                                                            <td>{booking.checkindate || '-'} {booking.checkintime || '-'}</td>
                                                            <td>{item.paymode1 || '-'}</td>
                                                            <td>{amount1.toFixed(2)}</td>
                                                            <td>{item.paymode2 || '-'}</td>
                                                            <td>{amount2.toFixed(2)}</td>
                                                            <td>{totalAmount.toFixed(2)}</td>
                                                            <td>
                                                                {rooms.map((r, i) => (
                                                                    <span key={i}>{r.roomname}{i !== rooms.length - 1 && ', '}</span>
                                                                ))}
                                                            </td>
                                                            <td>
                                                                <a target='blank' href={'/print-invoice/' + item.bookingid} className='btn btn-info btn-sm'><i className="fa fa-print"></i></a>&nbsp;
                                                                {/* <a href="#0" className='btn btn-success btn-sm'><i className="fa fa-cutlery"></i> <i className="fa fa-print"></i></a>&nbsp; */}

                                                            </td>
                                                        </tr>
                                                    );
                                                });

                                                return (
                                                    <>
                                                        {rows}
                                                        <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                                                            <td colSpan="8" style={{ textAlign: "right" }}>All Total</td>
                                                            <td>{grandTotal.toFixed(2)}</td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                    </>
                                                );
                                            })() : (
                                                <tr>
                                                    <td colSpan="11" className="text-center">No payment data found.</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>


                                </table>
                            </div>
                        </div>
                    </div>
                </section >

            </div>



        </div >

    )
}

export default Paymodecheckouts
